
import React, { useContext, useState } from 'react';
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import { assets } from '../assets/assets';
import logo from '../images/mahikalogo.jpg';
import { StoreContext } from '../context/StoreContext';

const Navbar = ({ setShowLogin }) => {
    const [menuActive, setMenuActive] = useState(false);
    const { getTotalCartAmount } = useContext(StoreContext);
    const { token, setToken } = useContext(StoreContext);

    const navigate = useNavigate();

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setToken(null);
        navigate("/");
    };

    const toggleMenu = () => {
        setMenuActive(!menuActive);
    };

    return (
        <div className="navbar">
            <img src={logo} className="img" alt="Mahika Cafe Logo" />
            <div className="hamburger" onClick={toggleMenu}>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <ul className={`navbar-menu ${menuActive ? 'active' : ''}`}>
                <li><Link style={{ textDecoration: 'none' }} to="/">Home</Link></li>
                <li><Link style={{ textDecoration: 'none' }} to="/Menu">Menu</Link></li>
                <li><Link style={{ textDecoration: 'none' }} to="/AboutUs">About Us</Link></li>
            </ul>
            <div className="navbar-right">
                <div className="navbar-search-icon">
                    <Link to='/cart'><img src={assets.basket_icon} alt="Cart" /></Link>
                    <div className={getTotalCartAmount() === 0 ? "" : "dot"}></div>
                </div>
                {!token ? <button onClick={() => setShowLogin(true)}>Sign In</button>
                    : <div className="navbar-profile">
                        <img src={assets.profile_icon} alt="Profile" />
                        <ul className="nav-profile-dropdown">
                            <li onClick={() => navigate('/orders')}><img src={assets.bag_icon} alt="Orders" /><p>Orders</p></li>
                            <hr />
                            <li onClick={logout}><img src={assets.logout_icon} alt="Logout" /><p>Logout</p></li>
                        </ul>
                    </div>}
            </div>
        </div>
    );
}

export default Navbar;
